module.exports = __webpack_public_path__ + "img/facing.jpg?fe82c446efc64d241f5cd6a483896f5a";